import { __module as unsupportedIterableToArray } from '../../../../_virtual/unsupportedIterableToArray.js';
import './arrayLikeToArray.js';
import { exports as arrayLikeToArrayExports } from '../../../../_virtual/arrayLikeToArray.js';

(function (module) {
	var arrayLikeToArray = arrayLikeToArrayExports;
	function _unsupportedIterableToArray(r, a) {
	  if (r) {
	    if ("string" == typeof r) return arrayLikeToArray(r, a);
	    var t = {}.toString.call(r).slice(8, -1);
	    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
	  }
	}
	module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (unsupportedIterableToArray));
//# sourceMappingURL=unsupportedIterableToArray.js.map
